const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    country_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "country_masters",
    schema: schema,
  };

  const navigatePage = { back: "/country-list" };

  const headerName = "Country";

  const validationType = "CountryCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  const dependentDropdownData = [
    {
      module_name: "country_masters",
      initialPayload: {
        modelName: "country_masters",
        schema: schema,
        whereCondition: { is_child: false },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "country_name",
      dropdownDataValue: "parent_id",
      endPoint: "/getRecords",
    },
  ];
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "country_masters",
    schema: schema,
    // "include": [
    //   {
    //     "model": "user_masters",
    //     "as": "user"
    //   }
    // ]
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Country Name", value: "country_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/country-create",
    edit: "/country-create",
    view: "/country-view",
  };

  const searchfields = ["country_name"];

  const headerName = "Country";
  const endpoint = "/getRecords";
  const exportFileName = "countryData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "country_masters",
  schema: schema,
  // relations: [
  //   { module: "user_masters", moduleAs: "users" },
  //   { module: "user_masters", moduleAs: "users" },
  // ],
  pagination: { page: 1, pageSize: 10000 },
};
